import { render, staticRenderFns } from "./MessageTypeSelect.vue?vue&type=template&id=05321ee4&"
import script from "./MessageTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./MessageTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports